import React from 'react';
import PropTypes from 'prop-types';

import FormList from 'core/components/form-list';
import Car from './car';
import AddCar from './add-car';

const Cars = ({ disabled, ...rest }) => {
  return (
    <FormList
      disabled={disabled}
      id="cars"
      item={Car}
      addForm={AddCar}
      title="Cars"
      singular="car"
      plural="cars"
      {...rest}
    />
  );
};

Cars.propTypes = {
  disabled: PropTypes.bool
};

Cars.defaultProps = {
  disabled: false
};

export default Cars;
